export type Coordinate = [longitude: number, latitude: number]

/** Track and route points of a GPX file as one line, in file order. Everything else (elevation, time, waypoints) is ignored. */
export function parseGpx(text: string): Coordinate[] {
  const document = new DOMParser().parseFromString(text, 'application/xml')

  return Array.from(document.querySelectorAll('trkpt, rtept'))
    .map((point): Coordinate => [Number(point.getAttribute('lon')), Number(point.getAttribute('lat'))])
    .filter(([longitude, latitude]) => Number.isFinite(longitude) && Number.isFinite(latitude))
}
